import { render, staticRenderFns } from "./WaitingRoomView.vue?vue&type=template&id=851f0c88&scoped=true"
import script from "./WaitingRoomView.vue?vue&type=script&lang=js"
export * from "./WaitingRoomView.vue?vue&type=script&lang=js"
import style0 from "./WaitingRoomView.vue?vue&type=style&index=0&id=851f0c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851f0c88",
  null
  
)

export default component.exports